import React from 'react';

const PageLoader = () => {
	return (
		<div className="vh-100 d-flex justify-content-center align-items-center">
			<span
				className="Page_loader"
				role="status"
				aria-hidden="true"
			></span>
		</div>
	);
};

export default PageLoader;

export const PageSmallLoader = () => {
	return (
		<div
			className="Page_loader"
			style={{ width: '30px', height: '30px' }}
		></div>
	);
};
